<template>
    <div>
        <v-select :multiple="true" :options="optionsPromocion" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedPromocion" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "tipoPromocion",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedPromocion:[],
            optionsPromocion:[]
        }
    },
    mounted() {
        this.getGestores();
    },
    methods:{
        getGestores(){ let $this = this;
            axios
                .post('/api/AdminCatalogos/getPromociones')
                .then(function (r){
                    $this.optionsPromocion = r.data;
                });
        },
        setCambio(){
            this.$emit('cambioPromocion');
        }

    }
}
</script>

<style scoped>

</style>
